import store from 'store';

export default [() => {
    let storeService = { functions: {} };

    storeService.functions.get = (key) => {
        return store.get(key);
    };

    storeService.functions.set = (key, value) => {
        return store.set(key, value);
    };

    storeService.functions.remove = (key) => {
        return store.remove(key);
    };

    return storeService.functions;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/store.service.js